import styled from '@emotion/styled'

import { FieldErrorText } from '@cash-web/shared-feature-form'

import { GenericMoneyInput, GenericMoneyInputProps } from '../GenericMoneyInput'
import { GiantInput } from '../GiantInput/GiantInput'

const GIANT_INPUT_PLACEHOLDER = '$0'

const Container = styled.div`
  position: relative;

  input:focus + div {
    border: 2px solid ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
  }
`

const MultiplierCount = styled.div`
  min-width: 3rem;
  height: 2rem;
  padding: 0.625rem 0.75rem 0.75rem 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 1.5rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
  border-radius: 2rem;
  border: 2px solid ${({ theme }) => theme.colors.label};
  color: ${({ theme }) => theme.colors.label};
  ${props => props.theme.typography.labelDefault}
`

export const GiantMoneyInput = ({
  name,
  minimumAmount,
  maximumAmount,
  formattedValue,
  setFormattedValue,
  multiplierNumber = 0,
  ariaLabel,
  ...props
}: {
  multiplierNumber?: number
  ariaLabel?: ({ formattedValue, multiplierNumber }: { formattedValue: string; multiplierNumber: number }) => string
} & Omit<GenericMoneyInputProps, 'ariaLabel'>) => {
  return (
    <Container>
      <Container>
        <GenericMoneyInput
          customInput={GiantInput}
          name={name}
          minimumAmount={minimumAmount}
          maximumAmount={maximumAmount}
          formattedValue={formattedValue}
          setFormattedValue={setFormattedValue}
          ariaLabel={
            ariaLabel
              ? ariaLabel({
                  formattedValue: formattedValue || GIANT_INPUT_PLACEHOLDER,
                  multiplierNumber,
                })
              : undefined
          }
          placeholder={GIANT_INPUT_PLACEHOLDER}
          prefix="$"
          shouldAutoFocus={true}
          {...props}
        />
        {multiplierNumber > 1 && (
          <MultiplierCount>
            {
              // eslint-disable-next-line i18next/no-literal-string
              <p>x{multiplierNumber}</p>
            }
          </MultiplierCount>
        )}
      </Container>
      <FieldErrorText name={name} />
    </Container>
  )
}
